import React from 'react'
import styles from './ContentContainer.module.scss'

interface ContentContainerProps {
  children: React.ReactNode
}

const ContentContainer = ({ children }: ContentContainerProps) => <div className={styles.root}>{children}</div>

export default ContentContainer
